import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AutoEvaluationPage() {
  const { token } = useParams();
  const [e, setE] = useState(null);
  const [rep, setRep] = useState([]);
  const [etat, setEtat] = useState('chargement');

  useEffect(() => {
    fetch(`${API}/api/rh/entretiens/public/${token}`).then(async (r) => {
      if (!r.ok) return setEtat('invalide');
      const d = await r.json();
      setE(d); setRep(d.questions.map(() => ''));
      setEtat(d.statut === 'envoye' ? 'pret' : 'fait');
    });
  }, [token]);

  const envoyer = async () => {
    setEtat('envoi');
    const r = await fetch(`${API}/api/rh/entretiens/public/${token}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ reponses: rep }),
    });
    setEtat(r.ok ? 'fait' : 'pret');
  };

  if (etat === 'chargement') return <div className="min-h-screen grid place-items-center"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  if (etat === 'invalide') return <p data-testid="autoeval-invalide" className="p-10 text-center text-stone-600">Ce lien n'est pas valide.</p>;
  if (etat === 'fait') return (
    <div data-testid="autoeval-merci" className="min-h-screen grid place-items-center bg-stone-50 p-6 text-center">
      <div><CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto mb-3" /><p className="text-lg font-semibold">Merci, votre auto-évaluation est bien enregistrée.</p>
        <p className="text-sm text-stone-500 mt-1">Elle servira de base à votre entretien annuel.</p></div>
    </div>
  );

  return (
    <div data-testid="autoeval-page" className="min-h-screen bg-stone-50 py-10 px-4">
      <div className="max-w-2xl mx-auto bg-white border border-stone-200 rounded-2xl p-6 sm:p-8">
        <p className="text-xs uppercase tracking-wider text-emerald-700 font-semibold">{e.societe_nom}</p>
        <h1 className="text-2xl font-bold text-stone-900 mt-1">Auto-évaluation {e.annee}</h1>
        <p className="text-sm text-stone-500 mt-1 mb-6">{e.salarie_nom}, prenez quelques minutes pour répondre librement. Vos réponses préparent votre entretien annuel.</p>
        <div className="space-y-5">
          {e.questions.map((q, i) => (
            <div key={i}>
              <label className="text-sm font-medium text-stone-800">{i + 1}. {q}</label>
              <Textarea data-testid={`autoeval-reponse-${i}`} className="mt-1.5" rows={3} value={rep[i]}
                onChange={(ev) => setRep(rep.map((x, j) => (j === i ? ev.target.value : x)))} />
            </div>
          ))}
        </div>
        <Button data-testid="autoeval-envoyer-btn" onClick={envoyer} disabled={etat === 'envoi'} className="mt-6 w-full rounded-full bg-emerald-700 hover:bg-emerald-800">
          {etat === 'envoi' ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}Envoyer mon auto-évaluation
        </Button>
      </div>
    </div>
  );
}
